export default "__VITE_ASSET__DcD3MvC9__"